import React from 'react';
import ImageGallerychidrenwings from '../components/ImageGallerychidrenwings';
// import IRCTVDonationCard from "./IRCTVDonationCard";

const IRCconference = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
           <button 
          onClick={() => window.history.back()}
          style={{
            marginBottom: '10px',
            padding: '8px 10px',
            backgroundColor: '#255fe8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          ← Back to All Activities
        </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerychidrenwings />

                    {/* IRC 10 Days Conference */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>CHILDREN'S WING</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                               Alhamdulillaah, this wing is a boon to the society. It helps our new generation to excel in both religious and worldly education. It creates an enthusiasm amongst the children to know more about Islam and enable them to grow in an Islamic environment along with modern education system. IRC organizes Islamic Summer Camps (ISC) for boys & girls under this wing annually.
                            </p>
                        </div>
                                    {/* <IRCTVDonationCard 
               title="CHILDREN'S WING"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: CHILDREN'S WING"
            /> */}
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCconference;
